import React from 'react';
import { Table, Pagination } from 'react-bootstrap';
import moment from 'moment';

const ITENS_POR_PAGINA = 20;

const formatarData = (valor) => {
  if (!valor) return '';
  const m = moment(valor);
  if (!m.isValid()) return '';
  // FD-5: data sentinela Delphi 30/12/1899 → célula vazia
  if (m.year() === 1899) return '';
  return m.format('DD/MM/YYYY');
};

const formatarDecimal = (valor) => {
  if (valor == null) return '';
  return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const TabelaImoveisEstoque = ({ resultado, pagina, onPaginaChange, mostrarPontuacao }) => {
  if (!resultado || !resultado.length) return null;

  const total = resultado.length;
  const totalPaginas = Math.ceil(total / ITENS_POR_PAGINA);
  const paginaAtual = pagina || 1;
  const inicio = (paginaAtual - 1) * ITENS_POR_PAGINA;
  const fim = Math.min(inicio + ITENS_POR_PAGINA, total);
  const itensPagina = resultado.slice(inicio, fim);

  // Paginação: exibir até 5 páginas com ellipsis (padrão ConversaoLeads)
  const construirPaginas = () => {
    const paginas = [];
    const delta = 2;
    const esquerda = Math.max(2, paginaAtual - delta);
    const direita = Math.min(totalPaginas - 1, paginaAtual + delta);

    paginas.push(1);
    if (esquerda > 2) paginas.push('...');
    for (let i = esquerda; i <= direita; i++) paginas.push(i);
    if (direita < totalPaginas - 1) paginas.push('...');
    if (totalPaginas > 1) paginas.push(totalPaginas);
    return paginas;
  };

  let agrupamentoAnterior = null;

  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <Table striped bordered hover size="sm" style={{ minWidth: '1800px', fontSize: '0.8rem' }}>
          <thead>
            <tr>
              <th>GE</th>
              <th>Empreendimento</th>
              <th>Cidade</th>
              <th>Código</th>
              <th>Área</th>
              <th>Qd/Lt</th>
              <th>Status</th>
              <th>Desde</th>
              <th>Cad. Pref.</th>
              <th>Cad. Água</th>
              <th>VV</th>
              <th>VLM</th>
              {mostrarPontuacao && <th>Pontuação</th>}
              <th>Observação</th>
              <th>Custo Médio</th>
              <th>Moeda Padrão</th>
              <th>Corretor</th>
              <th>Agrupamento</th>
              <th>Mapa 1</th>
              <th>Mapa 2</th>
              <th>Cód. GE</th>
              <th>Fator</th>
            </tr>
          </thead>
          <tbody>
            {itensPagina.map((item) => {
              const novoAgrupamento = item.agrupamento_2 !== agrupamentoAnterior;
              agrupamentoAnterior = item.agrupamento_2;
              const colSpan = mostrarPontuacao ? 22 : 21;
              return (
                <React.Fragment key={item.codigo_ativo}>
                  {novoAgrupamento && item.agrupamento_2 && (
                    <tr className="table-secondary">
                      <td colSpan={colSpan} className="font-weight-bold">
                        {item.agrupamento_2}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>{item.ge || ''}</td>
                    <td>{item.nome_familia}</td>
                    <td>{item.cidade}</td>
                    <td>{item.codigo_ativo}</td>
                    <td className="text-right">{formatarDecimal(item.area)}</td>
                    <td>{item.quadra_lote}</td>
                    <td>{item.descricao_status}</td>
                    <td>{formatarData(item.desde_ultimo)}</td>
                    <td>{item.cad_prefeitura}</td>
                    <td>{item.cad_agua}</td>
                    <td className="text-right">{formatarDecimal(item.vv)}</td>
                    <td className="text-right">{formatarDecimal(item.vlm)}</td>
                    {mostrarPontuacao && (
                      <td className="text-right">
                        {item.fator != null && item.vv != null
                          ? formatarDecimal(item.fator * item.vv)
                          : ''}
                      </td>
                    )}
                    <td>{item.observacao}</td>
                    <td className="text-right">{formatarDecimal(item.custo_medio)}</td>
                    <td>{item.moeda_padrao}</td>
                    <td>{item.corretor}</td>
                    <td>{item.agrupamento_2}</td>
                    <td>{item.mapa1}</td>
                    <td>{item.mapa2}</td>
                    <td>{item.codigo_grupo_empresa}</td>
                    <td className="text-right">{formatarDecimal(item.fator)}</td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-2">
        <small className="text-muted">
          Mostrando {inicio + 1} até {fim} de {total} registros
        </small>
        {totalPaginas > 1 && (
          <Pagination size="sm" className="mb-0">
            <Pagination.First
              onClick={() => onPaginaChange(1)}
              disabled={paginaAtual === 1}
            />
            <Pagination.Prev
              onClick={() => onPaginaChange(paginaAtual - 1)}
              disabled={paginaAtual === 1}
            />
            {construirPaginas().map((p, idx) =>
              p === '...' ? (
                <Pagination.Ellipsis key={`ell-${idx}`} disabled />
              ) : (
                <Pagination.Item
                  key={p}
                  active={p === paginaAtual}
                  onClick={() => onPaginaChange(p)}
                >
                  {p}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => onPaginaChange(paginaAtual + 1)}
              disabled={paginaAtual === totalPaginas}
            />
            <Pagination.Last
              onClick={() => onPaginaChange(totalPaginas)}
              disabled={paginaAtual === totalPaginas}
            />
          </Pagination>
        )}
      </div>
    </div>
  );
};

export default TabelaImoveisEstoque;
